export default "__VITE_ASSET__DikxHl3S__"